module.exports = __webpack_public_path__ + "static/media/hockey-puck.7d2a01d5.svg";